import {
  adminBdEmail,
  adminCxEmail,
  adminFinanceEmail,
  adminCollectionEmail,
  adminNetworkEmail,
  adminOnboardingEmail,
} from 'configpath'

export function buildHandlebars(handlebars) {
  let newHandlebars = []
  Object.entries(handlebars).forEach(([key, value]) => {
    newHandlebars = [
      ...newHandlebars,
      {
        name: key,
        content: value,
      },
    ]
  })
  return newHandlebars
}

export function buildRecipients(to) {
  const adminEmails = {
    BD: adminBdEmail,
    Collection: adminCollectionEmail,
    Finance: adminFinanceEmail,
    CX: adminCxEmail,
    Network: adminNetworkEmail,
    Onboarding: adminOnboardingEmail,
  }
  const returned = to.map((each) => {
    if (each.admin) {
      return {
        name: `${each.admin} Team`,
        email: adminEmails[each.admin],
        type: each.type ? each.type : 'to',
      }
    }
    return {
      name: each.name || each.email,
      email: each.email,
      type: each.type ? each.type : 'to',
    }
  })
  return returned
}

export function buildEmail(payloads) {
  return {
    ...payloads,
    recipient: buildRecipients(payloads.recipient),
    criteria: {
      category: payloads.category,
      type: payloads.type,
    },
    handlebars: buildHandlebars(payloads.handlebars),
  }
}
